export default "__VITE_ASSET__CdN4TZVt__"